import { Component } from '@angular/core';

@Component({
  selector: 'app-execution',
  templateUrl: './execution.component.html',
  styleUrl: './execution.component.scss'
})
export class ExecutionComponent {

}
